export default "__VITE_ASSET__0j45yP1x__"